module.exports = __webpack_public_path__ + "img/ht_icon_timelapse_line.06b21cbe.svg";